'use client';

import { createIntl } from '@formatjs/intl';
import type { userAgent } from 'next/server';
import { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import MapProvider from '@alltrails/maps/components/MapProvider/MapProvider';
import type { MapState } from '@alltrails/maps/redux/reducer';
import type { Bootstrap } from '@alltrails/networking/types/Bootstrap';
import type CountryCode from '@alltrails/types/CountryCode';
import type Experiments from '@alltrails/types/Experiments';
import { buildStore } from '../utils/redux';

type Props = {
  bootstrap: Bootstrap;
  browser: ReturnType<typeof userAgent>['browser'];
  experiments: Experiments;
  messages: ReturnType<typeof createIntl>['messages'];
  locale: ReturnType<typeof createIntl>['locale'];
  irclickid?: string;
  map: MapState;
  requestCountryCode: CountryCode;
};

export default function CustomProvider({
  bootstrap,
  browser,
  experiments,
  messages,
  locale,
  children,
  irclickid,
  map,
  requestCountryCode
}: PropsWithChildren<Props>) {
  const store = buildStore({
    algoliaConfigs: bootstrap.algoliaConfig,
    amplitudeAnalyticsSettings: bootstrap.amplitudeAnalyticsSettings,
    browser,
    context: bootstrap.context,
    currencyCode: bootstrap.currencyCode,
    experiments,
    features: bootstrap.features,
    irclickid,
    plans: bootstrap.plans,
    requestCountryCode,
    map
  });

  return (
    <IntlProvider messages={messages} locale={locale}>
      <Provider store={store}>
        <MapProvider>{children}</MapProvider>
      </Provider>
    </IntlProvider>
  );
}
